import { Button } from "@/shared/ui/button.tsx";
import { useNavigate } from "react-router-dom";
import heroImg from "@assets/hero-img.png"
import { motion } from "motion/react";

const Hero = () => {
  const navigate = useNavigate()
  return (
<div className="min-h-[70vh] sm:min-h-screen w-full flex flex-col relative items-center justify-center md:justify-start pt-16 md:pt-24 overflow-hidden -mt-[5vh]">
  <motion.span 
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
    className="absolute z-50 top-24 sm:top-40 md:top-20 animate-bounce-up-down w-1/3 lg:w-1/4 left-[30%] lg:left-[40%] -translate-x-[50%]"
  >
    <img src={heroImg} className="w-full h-auto" />
  </motion.span>
  
  <motion.h1 
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: "easeOut" }}
    className="pb-3 leading-tight font-bold  text-[6rem] sm:text-[10rem] md:text-[13rem] lg:text-[17rem] font-montserrat text-center bg-gradient-to-b from-[#6519CF] to-[#320177] inline-block text-transparent bg-clip-text"
  >
    siAiOS
    <sup className="align-super text-[4rem] md:text-[6rem] font-bold bg-gradient-to-b from-[#6519CF] to-[#320177] text-transparent bg-clip-text">
      2
    </sup>
  </motion.h1>
  
  <motion.h2 
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
    className="font-montserrat font-bold text-3xl md:text-6xl text-[#390088] text-center"
  >
    Your brand's living brain
  </motion.h2>
  
  <motion.p 
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, delay: 0.6, ease: "easeOut" }}
    className="md:text-lg px-2 md:px-10 text-center font-poppins font-light py-8 text-[#2A0163] max-w-xl relative z-50"
  >
    <span className="font-semibold">OS² is your bespoke, on-BRAND AGENTIC AI</span>
    <br />delivering an agency-grade experience at SaaS speed.
  </motion.p>
  
  <motion.div 
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, delay: 0.8, ease: "easeOut" }}
    className="relative flex items-center gap-2 justify-center w-full z-20"
  >
    <Button variant="outline" onClick={() => navigate('/contact')} className="rounded-full font-poppins text-xs sm:text-sm tracking-wide px-5 py-6">Schedule a Demo</Button>
    <Button className="bg-gradient-to-b from-[#320177] to-[#5D02DD] rounded-full font-poppins text-xs sm:text-sm tracking-wide px-5 py-6" onClick={() => navigate('/contact')}>Join as a Design Partner</Button>
  </motion.div>
</div>
  )
}

export default Hero;
